export enum SammInstanceTypes {
  single = 1,
  premises = 2,
  company = 4,
  portfolio = 5,
}

export interface SammInstanceTypeDto {
  id: number;
  instanceTypeName: string;
  instanceTypeShortName: string;
}

export interface SammInstanceTypeReferenceDto {
  id: number;
  name: string;
   
  additionalProperties?: { [key: string]: unknown };
}

export interface SammInstanceTypeDetailsDto extends SammInstanceTypeDto {
  references: SammInstanceTypeReferenceDto[];
}

export type ExtendedCompanySammInstanceTypeReferenceDto = SammInstanceTypeReferenceDto & {
   
  additionalProperties?: { [key: string]: unknown };
};
